import React from 'react';

// MuzzleFace — §2 面部 — 鼻梁/鼻头/脸部/嘴唇 (bridge/nose/muzzle/muzzle-lip-color) + eye area + seams
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleFace({ config, parts, lines, rects }) {
  return (
    <>
<line className="clear str_222222_50" x1={(lines['line-1'] || {}).x1} y1={(lines['line-1'] || {}).y1} x2={(lines['line-1'] || {}).x2} y2={(lines['line-1'] || {}).y2} />
<g id="_2100834368480">
<path className={"hood-" + config['muzzle-color'] + " str_222222_50"} d={parts['muzzle-color_c'] || ''}/>
<path className="clear str_222222_30_150_90" d={parts['clear-path-27'] || ''}/>
</g>
<g id="_2100834367904">
<path className={"hood-" + config['muzzle-lip-color'] + " str_222222_50"} d={parts['muzzle-lip-color_c'] || ''}/>
<path className="clear str_222222_25_125_125" d={parts['clear-path-29'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-30'] || ''}/>
</g>
<g id="_2100839941424">
<rect className="fil-eye-border  str_222222_50" transform={(rects['eye-border-rect-1'] || {}).transform} width={(rects['eye-border-rect-1'] || {}).width} height={(rects['eye-border-rect-1'] || {}).height} rx="127" ry="127"/>
<path className={"hood-" + config['bridge-color'] + " str_222222_50"} d={parts['bridge-color_c'] || ''}/>
<line className="clear str_222222_50" x1={(lines['line-2'] || {}).x1} y1={(lines['line-2'] || {}).y1} x2={(lines['line-2'] || {}).x2} y2={(lines['line-2'] || {}).y2} />
<path className="clear str_222222_25_125_75" d={parts['clear-path-32'] || ''}/>
<line className="clear str_222222_20_40_20" x1={(lines['line-3'] || {}).x1} y1={(lines['line-3'] || {}).y1} x2={(lines['line-3'] || {}).x2} y2={(lines['line-3'] || {}).y2} />
<line className="clear str_222222_20_40_20" x1={(lines['line-4'] || {}).x1} y1={(lines['line-4'] || {}).y1} x2={(lines['line-4'] || {}).x2} y2={(lines['line-4'] || {}).y2} />
<path className="clear str_222222_20_40_20" d={parts['clear-path-33'] || ''}/>
</g>
<g id="_2100929838640">
<path className={"hood-" + config['nose-color']} d={parts['nose-color_c'] || ''}/>
<path className="fil-nose" d={parts['nose-path-35'] || ''}/>
<path className="fil-nose" d={parts['nose-path-36'] || ''}/>
<path className="clear str_222222_50" d={parts['clear-path-37'] || ''}/>
<path className="clear str_222222_30" d={parts['clear-path-38'] || ''}/>
<path className="clear str_222222_30" d={parts['clear-path-39'] || ''}/>
<path className="clear str_222222_30_150_150" d={parts['clear-path-40'] || ''}/>
<path className="clear str_222222_25_125_75" d={parts['clear-path-41'] || ''}/>
<path className="clear str_222222_30" d={parts['clear-path-42'] || ''}/>
<path className="clear str_222222_25" d={parts['clear-path-43'] || ''}/>
</g>
    </>
  );
}
